/* eslint-disable camelcase */
import React from 'react';
import {
  withStyles,
} from '@material-ui/core';
import PropTypes from 'prop-types';
import { DispatchDragNDropTypes } from '~/utils';
import { useDrop } from 'react-dnd';
import styles from '../styles';
import PF2MEquipIcon from '~/components/PF2MEquipIcon';
import PF2MDispatchIconMaker from '~/components/PF2MDispatchIconMaker';
import PF2MTooltip from '~/components/PF2MTooltip';

const AllocationRow = ({
  subelement, perforators,
  onEquipClick,
  classes,
  onPerforatorDrop,
}) => {
  const [, perforatorDrop] = useDrop({
    accept: DispatchDragNDropTypes.PERFORATOR,
    drop: (monitor) => {
      onPerforatorDrop({ spa: monitor.obj, subelement });
    },
    collect: monitor => ({
      dragItem: monitor.getItem(),
    }),
  });

  if (perforators.length === 0) {
    return null;
  }

  return (
    <div
      key={subelement.id}
      style={{
        display: 'flex',
        height: 'fit-content',
        border: '1px solid #CDCDCD',
        backgroundColor: '#dedede',
      }}
    >
      <PF2MTooltip
        title={subelement.name}
        PopperProps={{ disablePortal: true }}
      >
        <div
          className={classes.subelementIcon}
          style={{
            display: 'flex',
            flexDirection: 'column',
            width: '90px',
            overflow: 'hidden',
          }}
        >
          <PF2MDispatchIconMaker
            iconName="material"
            settings={{
              iconSize: 50,
              alt: subelement.name,
            }}
          />
          <div
            className={classes.labelTypeSelectorSubelement}
            style={{
              textAlign: 'center',
              cursor: 'default',
            }}
          >
            {subelement.name.slice(0, 10)}
          </div>
        </div>
      </PF2MTooltip>
      <div>
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            padding: '8px',
          }}
          ref={perforatorDrop}
        >
          {perforators
            .map(perforator => (
              <PF2MEquipIcon
                key={perforator.id}
                item={{ ...perforator, equip_type_id: perforator.equipaments_id }}
                customStyles={{
                  marginLeft: 15,
                }}
                itemType={DispatchDragNDropTypes.PERFORATOR}
                onClick={() => onEquipClick(perforator)}
                reverse
              />
            ))}
        </div>
      </div>
    </div>
  );
};

AllocationRow.propTypes = {
  subelement: PropTypes.object,
  onEquipClick: PropTypes.func,
  onPerforatorDrop: PropTypes.func,
  perforators: PropTypes.array,
  classes: PropTypes.object,
};

AllocationRow.defaultProps = {
  subelement: {},
  onEquipClick: () => {},
  onPerforatorDrop: () => {},
  perforators: [],
  classes: {},
};

export default withStyles(styles)(AllocationRow);
